<template>
  <div class="inline">
    <VField ref="vFieldRef" :class="props.inputClass" name="spaceName" :placeholder="props.placeholder" v-model="state.value" @onBlur="handleBlur" @iconClick="vFieldRef.blur()" @onFocus="state.isEditing = true"></VField>
    <Button ref="buttonRef" :class="props.buttonClass" class="icon square" :icon="state.isEditing ? 'bi-check2' : 'bi-pencil'" @click="updateValue"></Button>
  </div>
</template>

<script setup lang="ts">
import VField from '@/components/global/VField.vue';
import Button from '@/components/global/Button.vue';

const emit = defineEmits(["update:modelValue"]);

const buttonRef = ref(undefined);
const vFieldRef = ref(undefined);

const props = defineProps<{
  modelValue: string,
  inputClass?: string,
  buttonClass?: string,
  placeholder?: string,
}>();

const state = reactive<{
  value: string,
  isEditing: boolean,
}>({
  value: "",
  isEditing: false,
});

function handleBlur(e: Event) {
  const nextFocused = e?.relatedTarget;

  // If focus moved into the button area, ignore the blur
  if (buttonRef.value && nextFocused && buttonRef.value.el.contains(nextFocused)) {
    return;
  }
  

  updateValue();
}

function updateValue() {
  if (state.isEditing) {
    state.isEditing = false;
    emit('update:modelValue', state.value);
  } else {
    state.isEditing = true;
  }
}

watch(() => props.modelValue, (newValue) => {
  state.value = props.modelValue;
});

onMounted(() => {
  state.value = props.modelValue;
});
</script>

<style lang="scss" scoped>

.inline {
  width: 100%;
  display: flex;
  gap: 4px;
  align-items: center;

  .input-wrapper {
    flex: 1;
  }

  .btn {
    flex-shrink: 0;
  }
}
</style>